var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUnion = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46863 0.375977H5.53113C5.44779 0.375977 5.40613 0.417643 5.40613 0.500977V5.40723H0.750244C0.666911 5.40723 0.625244 5.44889 0.625244 5.53223V6.46973C0.625244 6.55306 0.666911 6.59473 0.750244 6.59473H5.40613V11.501C5.40613 11.5843 5.44779 11.626 5.53113 11.626H6.46863C6.55196 11.626 6.59363 11.5843 6.59363 11.501V6.59473H11.2502C11.3336 6.59473 11.3752 6.55306 11.3752 6.46973V5.53223C11.3752 5.44889 11.3336 5.40723 11.2502 5.40723H6.59363V0.500977C6.59363 0.417643 6.55196 0.375977 6.46863 0.375977Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnion, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Union.80fdaf3b.svg";
export { ForwardRef as ReactComponent };